
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppTag",
  emits: ["remove-tag-click", "update:input"],
  props: {
    tag: Object,
  },
  data() {
    return {};
  },
  methods: {
    removeClick() {
      this.$emit("remove-tag-click", this.tag?.id);
    },
    onChange(event: Event) {
      const inputElement = event.target as HTMLInputElement;
      this.$emit("update:input", inputElement.textContent);
    },
  },
  watch: {},
  mounted() {
    if (this.tag && !this.tag.isValidated) {
      (this.$refs["tag"] as HTMLInputElement).focus();
    }
  },
});
